import dayjs, { extend } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import utc from 'dayjs/plugin/utc';

extend(utc);
extend(isBetween);
extend(isSameOrAfter);

const now = dayjs.utc();

export const submissionsAreClosed = (submission_ends_at, nowTime = now): boolean =>
    nowTime.isSameOrAfter(dayjs.utc(submission_ends_at), 'ms');
export const gameHasStarted = (submission_starts_at, nowTime = now): boolean =>
    nowTime.isSameOrAfter(dayjs.utc(submission_starts_at), 'ms');
export const gameHasEnded = (ends_at, nowTime = now): boolean => nowTime.isSameOrAfter(dayjs.utc(ends_at), 'ms');
